export default "__VITE_ASSET__Bzd7305U__"